import React from 'react';
import PropTypes from 'prop-types';

/**
 * A simple layout wrapper for form fields.
 * Handles the label, children (the input), and error display.
 *
 * This component does NOT touch react-hook-form.
 * Each child component is responsible for its own form registration.
 *
 * @param {Object} props
 * @param {string} props.label - The text label displayed above the field
 * @param {React.ReactNode} props.children - The input element(s)
 * @param {string} [props.errorMessage] - Error message to display below the field

 */
export default function FieldWrapper({ label, children, errorMessage }) {
  return (
    <div className="flex flex-col">
      {/** biome-ignore lint/a11y/noLabelWithoutControl: `children` is an input element */}
      <label className="fl  flex-col">
        <span className="lg:h-14 flex items-end pb-2 text-sm font-semibold text-gray-700 leading-tight">
          {label}
        </span>
        {children}
      </label>
      {errorMessage && (
        <div className="pt-1 text-xs text-coral-96" role="alert">
          {errorMessage}
        </div>
      )}
    </div>
  );
}

FieldWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
};
